<template>
  <div class="facet-term">
    <div
      class="filter-checkbox"
      :class="{ checked: active }"
      @click="termClick"
    />
    <NuxtLink :to="to" class="font-light text-lg"
      >{{ label }} ({{ count }})</NuxtLink
    >
  </div>
</template>

<script lang="ts" setup>
const { buildFacetTermLink } = useProductSearch()

const props = defineProps<{
  facetId: string
  label: string
  count: number
  termKey: string
}>()

const router = useRouter()

const { to, active } = buildFacetTermLink(props.facetId, props.termKey)

function termClick() {
  router.push(to.value)
}
</script>

<style lang="postcss">
.facet-term {
  display: flex;
  align-items: center;

  a {
    display: block;
    flex: 1;
    padding: 0.25rem 0;
  }

  .pill {
    margin-left: auto;
    text-align: center;
  }

  input {
    margin-right: 0.5rem;
  }
}

.filter-checkbox {
  @apply border-black border-1 rounded-none w-15 h-15 cursor-pointer;
  margin-right: 0.5rem;
  margin-top: -0.2rem;

  &:checked,
  &.checked {
    @apply bg-white border-black;
    background: white url('~/assets/symbols/check.svg') no-repeat 50% 50%;
  }
}
</style>
